import {
  Component,
  OnInit,
  ViewChild,
  PipeTransform,
  Pipe,
  Injectable,
  Directive,
  Inject,
  Input,
} from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { FormControl, FormGroup } from "@angular/forms";
import { DateAdapter } from "@angular/material/core";
import {
  MatDateRangeSelectionStrategy,
  DateRange,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
} from "@angular/material/datepicker";

import Swal from "sweetalert2/dist/sweetalert2.js";
import { MatSnackBar } from "@angular/material/snack-bar";

import { DatePipe } from "@angular/common";

import { PDFfile } from "src/app/device/PDFfile";
import { Router } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";

import { ChartComponent } from "ng-apexcharts";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

import { MatMenuTrigger } from "@angular/material/menu";

@Injectable()
export class MaxRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D>
{
  start: any;
  public delta: number;
  constructor(private _dateAdapter: DateAdapter<D>) {}

  selectionFinished(date: D, currentRange: DateRange<D>) {
    let { start, end } = currentRange;
    if (start == null || (start && end)) {
      start = date;
      end = null;
    } else if (end == null) {
      const maxDate = this._dateAdapter.addCalendarDays(start, this.delta);
      end = date ? (date > maxDate ? maxDate : date) : null;
    }

    return new DateRange<D>(start, end);
  }
  createPreview(
    activeDate: D | null,
    currentRange: DateRange<D>
  ): DateRange<D> {
    if (currentRange.start && !currentRange.end) {
      const maxDate = this._dateAdapter.addCalendarDays(
        currentRange.start,
        this.delta
      );
      const rangeEnd = activeDate
        ? activeDate > maxDate
          ? maxDate
          : activeDate
        : null;

      return new DateRange(currentRange.start, rangeEnd);
    }

    return new DateRange<D>(null, null);
  }
}

@Directive({
  selector: "[maxRange]",
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy,
    },
  ],
})
export class MaxRangeDirective {
  constructor(
    @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY)
    private maxRangeStrategy: MaxRangeSelectionStrategy<any>
  ) {}
  @Input() set maxRange(value: number) {
    this.maxRangeStrategy.delta = +value || 7;
  }
}

@Pipe({ name: "formatTime" })
export class FormatTime implements PipeTransform {
  transform(value: number): string {
    let minutes: number = Math.trunc(value / 60);
    let hours: number = 0;
    let seconds: number = value - minutes * 60;

    if (minutes >= 60) {
      hours = Math.trunc(minutes / 60);
      minutes = minutes - hours * 60;
    }

    let response: string = "";

    if (hours > 0) {
      response = response + Math.round(hours) + " h ";
    }

    if (minutes > 0) {
      response = response + Math.round(minutes) + " min ";
    }

    if (seconds > 0) {
      response = response + Math.round(seconds) + " sec";
    }

    return response;
  }
}

export type ChartOptions = {
  series: any;
  chart: any;
  xaxis: any;
  yaxis: any;
  title: any;
  fill: any;
  dataLabels: any;
  tooltips: any;
  annotations: any;
  stroke: any;
  markers: any;
  colors: string[];
  grid: any;
  legend: any;
};

export interface dataScore {
  name: string;
  x: number;
  y: number;
  z: number;
}

@Component({
  selector: "app-user-vehicule",
  templateUrl: "./user-vehicule.component.html",
  styleUrls: ["./user-vehicule.component.scss"],
})
export class UserVehiculeComponent implements OnInit {
  minDate: Date = new Date(2010, 1, 1);
  maxDate: Date = new Date();

  myModel = true;
  chartOptions16: any;
  chartOptions17: any;
  manualPage: number = 0;
  pageSize1: any;
  pageSize = 5;
  lengthpage: number;
  pageNum: any;
  manualPage1: number;
  lengthTotal: any;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [5, 10, 25, 100];
  public dateTime: Date;
  index2: any = 5;
  dd: any = 0;
  pageSizeOptions1: number[];
  gg: any;
  itemSelect: any = [];
  myControl = new FormControl();

  itemSelect2: any;
  hiddenContenu: string = "false";
  range: string;
  filterValue: string;
  repos2: any[];
  URL: RequestInfo;
  refrech1: number = 2017;
  dt: any;
  days: any;
  finalDate: any;
  hiddenDetails: boolean = false;
  dtformt: string = "M/d/yyyy";
  @ViewChild("paginator", { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  jj: string;
  tblhidden: string;
  typeMessage: string;
  dataSourcee: any;
  ELEMENT_DATAFILTER: any[];
  dataSource: MatTableDataSource<any>;
  getdt: string;
  panelOpenState = false;
  repos: any;
  reposdt: any;
  ELEMENT_DATAFILTER2: any;
  URL2: string;
  currentScore: any;
  type9: string;
  width9: string;
  height9: string;
  dataSource9: any;

  xValues: any;

  /*Graph */
  @ViewChild("chart") chart: ChartComponent;

  customColors: any;

  chartOptions: any;
  chartOptions2: any;
  chartOptions3: any;

  chartOptions4: any;
  chartOptions5: any;

  series1: any = [];
  ff: any = null;

  series3: any = [];
  series4: any = [];
  fff: any = [];

  yValues: any;
  evolutionScoreEconomie: boolean = true;
  evolutionScoreSecurite: boolean = true;
  typeEvenement: boolean = true;
  relationSecuriteEconomie: boolean = true;
  repartitionScoreSecurite: boolean = true;
  repartitionScoreEconomie: boolean = true;
  testFilter1: number;
  testFilter11: number;
  scoreS: any;
  scoreEc: any;
  distanceEntreMan: any;
  tmpinactivite: any;
  reposSc: any;
  sc_tnd_sec: any;
  sc_tnd_eco: any;
  min_dis_moy: any;
  dist_moy: any;
  max_dis_moy: any;
  min_vit_moy: any;
  max_vit_moy: any;
  vit_moy: any;

  listvehiculee: any;
  veh: any;

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: "0px", y: "0px" };

  canvasWidth: any;
  needleValue: any;
  centralLabel: any;
  name: any;
  bottomLabel: any;

  evo_sf_scores: any;
  evo_sf_score_cat: any;
  avg_evo_sf_score: any;
  reposChart: any;
  avg_evo_ec_score: any;
  evo_ec_scores: any;
  evo_ec_score_cat: any;
  reposRepartitionEC: any;
  reposRepartitionSF: any;
  unitsSF: any = [];
  reposRepartitionSF_avg: any;
  piePoint: any;
  pieStyle: any = [];
  pieColors: any = [];
  scoresSF: any = [];
  reposRepartitionEC_avg: any;
  unitsEC: any = [];
  scoresEC: any = [];
  pieStyleEC: any = [];
  pieColorsEC: any = [];
  reposRelationSF_EC: any;
  RelationEC_Avg: any;
  RelationSF_Avg: any;
  Relation_unitsEC_SF: any = [];
  series11: any[];
  formatVitesse: any;
  formatDist: any;
  unitsVitesse: string = "Vitesse moy";

  view: any[] = [380, 280];
  legendDist: boolean = false;
  legendPositionDist: string = "below";
  minDist: any = 0;
  maxDist: any = 0;
  colorSchemeDist: any = {
    domain: ["#5AA454"],
  };
  reposRepartitionTpEvents: any = [];
  result: any[];
  rangeFormGroup: FormGroup;

  singleDistance: { name: string; value: number }[];

  legendVitesse: boolean = false;
  legendPositionVitesse: string = "below";
  minVitesse: any = 0;
  maxVitesse: any = 0;
  colorSchemeVitesse: any = {
    domain: ["#fbb950"],
  };
  unitsDist: any = "Distance moy";
  smallSegments: any = 6;
  bigSegments: any = 2;
  singleVitesse: { name: string; value: number }[];
  angleSpan: any = 180;
  startAngle: any = -90;

  startDateValue: any;
  endDateValue: any;

  chartOptionds: any = {
    series: [
      {
        name: "My-series",
        data: [],
      },
    ],
    chart: {
      height: 400,
      type: "bar",
      width: "100%",
      dropShadow: {
        enabled: true,
        color: "#000",
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2,
      },
      toolbar: {
        show: true,
      },
    },
    colors: ["#51B373"],
    // title: {
    //   text: "Répartition des types d'évènement"
    // },
    markers: {
      size: 6,
      hover: {
        size: 16,
      },
    },
  };

  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    private http: HttpClient,
    private spinnerVehiculeUser: NgxSpinnerService
  ) {
    this.executeFunction();
  }

  getdd(e1, e2) {
    this.spinnerVehiculeUser.show();
    this.rangeForm.setValue({
      start: new Date(localStorage.getItem("startDateValue")),
      end: new Date(localStorage.getItem("endDateValue")),
    });
    this.result = [];
    this.unitsSF = [];
    this.scoresSF = [];
    this.unitsEC = [];
    this.scoresEC = [];

    this.pieColorsEC = [];
    this.pieStyleEC = [];
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/scores/vehicles/all/filter/" +
      e1 +
      "~" +
      e2;

    this.http.get(this.URL, requestOptions).subscribe(
      async (response) => {
        this.itemSelect = [];
        this.hiddenDetails = false;
        this.selectedRowIndex = -1;
        this.dataSource = new MatTableDataSource(this.listvehiculee);

        var list: any = response;

        this.dataSource = new MatTableDataSource(list?.units);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.reposSc = list;

        this.reposRepartitionSF =
          this.reposSc?.repartition_safety_score_chart?.repartition_safety_score;
        this.reposRepartitionEC =
          this.reposSc?.repartition_eco_score_chart?.repartition_eco_score;
        this.reposRepartitionSF_avg =
          this.reposSc?.repartition_safety_score_chart?.avg;

        this.reposRepartitionEC_avg =
          this.reposSc?.repartition_eco_score_chart?.avg;

        //events type Repartition:

        this.reposRepartitionTpEvents = this.reposSc?.global_repartition_events;

        var dataarray: any = [];
        var namearray: any = [];

        await this.reposRepartitionTpEvents.filter((obj) => {
          dataarray.push(obj.value);
        });
        await this.reposRepartitionTpEvents.filter((obj) => {
          namearray.push(obj.name);
        });
        this.chartOptionds = {
          series: [
            {
              name: "My-series",
              data: await dataarray,
            },
          ],
          chart: {
            height: 400,
            type: "bar",
            width: "100%",
            dropShadow: {
              enabled: true,
              color: "#000",
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2,
            },
            toolbar: {
              show: true,
            },
          },
          colors: ["#51B373"],
          // title: {
          //   text: "Répartition des types d'évènement"
          // },
          xaxis: {
            categories: namearray,
          },
          markers: {
            size: 6,
            hover: {
              size: 16,
            },
          },
        };
        //Relation Safety-Economy score

        this.reposRelationSF_EC = this.reposSc?.safety_eco_relation?.relation;
        this.RelationEC_Avg = this.reposSc?.safety_eco_relation?.avg_eco_score;
        this.RelationSF_Avg =
          this.reposSc?.safety_eco_relation?.avg_safety_score;

        this.scoreS = this.reposSc?.global_safety_score;
        this.scoreEc = this.reposSc?.global_eco_score;
        this.distanceEntreMan = this.reposSc?.global_km_between_maneuvers;
        this.tmpinactivite = this.reposSc?.global_idle_time;
        this.sc_tnd_eco = this.reposSc?.global_eco_score_tendency;
        this.sc_tnd_sec = this.reposSc?.global_safety_score_tendency;

        this.dist_moy = this.reposSc?.global_avg_distance?.avg_distance;
        this.min_dis_moy = this.reposSc?.global_avg_distance?.min;
        this.max_dis_moy = this.reposSc?.global_avg_distance?.max;

        this.vit_moy = this.reposSc?.global_avg_speed?.avg_speed;
        this.min_vit_moy = this.reposSc?.global_avg_speed?.min;
        this.max_vit_moy = this.reposSc?.global_avg_speed?.max;

        this.avg_evo_sf_score = this.reposSc?.evolution_safety_score_chart?.avg;
        this.evo_sf_scores =
          this.reposSc?.evolution_safety_score_chart.evolution_safety_score?.data;
        this.evo_sf_score_cat =
          this.reposSc?.evolution_safety_score_chart.evolution_safety_score?.categories;

        this.avg_evo_ec_score = this.reposSc?.evolution_eco_score_chart?.avg;
        this.evo_ec_scores =
          this.reposSc?.evolution_eco_score_chart.evolution_eco_score?.data;
        this.evo_ec_score_cat =
          this.reposSc?.evolution_eco_score_chart?.evolution_eco_score?.categories;
        for (let i = 0; i < this.reposRepartitionTpEvents?.length; i++) {
          if (this.reposRepartitionTpEvents[i]?.value < 55) {
            this.result.push({
              name: this.reposRepartitionTpEvents[i]?.name,
              value: "#E05A61",
            });
          } else if (this.reposRepartitionTpEvents[i]?.value < 75) {
            this.result.push({
              name: this.reposRepartitionTpEvents[i]?.name,
              value: "#FBB950",
            });
          } else if (this.reposRepartitionTpEvents[i]?.value < 101) {
            this.result.push({
              name: this.reposRepartitionTpEvents[i]?.name,
              value: "#51B373",
            });
          }
        }
        this.collection = [];
        this.customColors = this.result;

        var lgn: any = this.result.length;
        this.lengthpage = parseInt("" + (lgn + 1) / this.pageSize);

        //Create dummy data
        for (var i = 0; i < this.lengthpage + 1; i++) {
          this.collection.push(i + 1);
        }
        this.getChartGauge(
          this.dist_moy,
          this.max_dis_moy,
          this.min_dis_moy,
          this.vit_moy,
          this.max_vit_moy,
          this.min_vit_moy
        );

        for (let U in this.reposRepartitionSF) {
          this.unitsSF.push(this.reposRepartitionSF[U]?.units);
          this.scoresSF.push(this.reposRepartitionSF[U]?.interval + "%");

          if (this.reposRepartitionSF[U].avg_interval < 50) {
            var style = "verticalLines";
            var colors = "#E05A61";
          } else if (this.reposRepartitionSF[U].avg_interval < 75) {
            var style = "squares";
            var colors = "#FBB950";
          } else {
            var style = "horizontalLines";
            var colors = "#51B373";
          }

          this.pieStyle?.push(style);

          this.pieColors?.push(colors);
        }

        for (let U in this.reposRepartitionEC) {
          this.unitsEC.push(this.reposRepartitionEC[U]?.units);
          this.scoresEC.push(this.reposRepartitionEC[U]?.interval + "%");

          if (this.reposRepartitionEC[U]?.avg_interval < 50) {
            var style = "verticalLines";
            var colors = "#E05A61";
          } else if (this.reposRepartitionEC[U]?.avg_interval < 75) {
            var style = "squares";
            /* var colors = '#FF9900' */
            var colors = "#FBB950";
          } else {
            var style = "horizontalLines";
            /*  var colors = '#00B612' */
            var colors = "#51B373";
          }

          this.pieStyleEC?.push(style);

          this.pieColorsEC?.push(colors);
        }

        this.Relation_unitsEC_SF = [];
        this.series11 = [];
        for (let U in this.reposRelationSF_EC) {
          this.Relation_unitsEC_SF?.push(this.reposRelationSF_EC[U]);

          this.series11?.push([
            this.reposRelationSF_EC[U]?.eco_score,
            this.reposRelationSF_EC[U]?.safety_score,
            15,
            this.reposRelationSF_EC[U]?.id +
              "Name." +
              this.reposRelationSF_EC[U]?.name,
          ]);
        }

        this.getChrt(
          this.series11,
          this.reposSc?.safety_eco_relation?.avg_eco_score,
          this.reposSc?.safety_eco_relation?.avg_safety_score
        );
        this.getchrt4(
          this.unitsEC,
          this.pieStyleEC,
          this.pieColorsEC,
          this.reposRepartitionEC_avg,
          this.scoresEC
        );
        this.getchrt1(
          this.unitsSF,
          this.pieStyle,
          this.pieColors,
          this.reposRepartitionSF_avg,
          this.scoresSF
        );

        this.getchrt3(
          this.evo_sf_scores,
          this.evo_sf_score_cat,
          this.avg_evo_sf_score
        );
        this.getchrt2(
          this.evo_ec_scores,
          this.evo_ec_score_cat,
          this.avg_evo_ec_score
        );

        this._snackBar.open(
          "Filtrage par date effectuer " + e1 + " à " + e2,
          "Fermer",
          {
            duration: 2000,
          }
        );

        this.spinnerVehiculeUser.hide();
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });

        this.spinnerVehiculeUser.hide();
      }
    );
  }

  ngOnInit(): void {
    this.updateManualPage2(this.index2);

    this.rangeFormGroup = new FormGroup({
      start: new FormControl(new Date(localStorage.getItem("startDateValue"))),
      end: new FormControl(new Date(localStorage.getItem("endDateValue"))),
    });
    this.series1 = [];
  }

  getchrt2(e, e2, avg) {
    this.chartOptions5 = {
      series: [
        {
          name: '<img src="https://img.icons8.com/color/20/000000/natural-food.png"/> <b> Score économie </b>',
          data: e,
        },
      ],
      chart: {
        height: "300px",
        width: "100%",
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        toolbar: {
          show: true,
        },
      },
      colors: ["#1fb141", "#545454"],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "smooth",
      },

      title: {
        text: "",
        align: "left",
      },
      grid: {
        show: false,
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0,
        },
      },
      markers: {
        size: 6,
        hover: {
          size: 16,
        },
      },
      xaxis: {
        type: "category",
        categories: e2,
      },
      yaxis: {
        min: 0,
        max: 100,
        title: {
          text: "Score d'économie (%)",
        },
      },
      tooltip: {
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        },
        marker: {
          show: false,
        },
        y: {
          formatter: (values) => {
            return (
              values +
              ' %   <img src="https://img.icons8.com/color/20/000000/average-value.png"/>  Moyenne: ' +
              avg +
              "%"
            );
          },
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5,
      },
      annotations: {
        yaxis: [
          {
            y: avg,
            borderColor: "#00E396",
            label: {
              borderColor: "#00E396",
              style: {
                color: "#fff",
                background: "#00E396",
              },
              text: "Moyenne " + avg + "%",
            },
          },
        ],
      },
    };
  }

  getchrt3(e, e2, avg) {
    this.chartOptions3 = {
      series: [
        {
          name: ' <img src="https://img.icons8.com/color/20/000000/warning-shield.png"/> <b> Score sécurité </b>',
          data: e,
        },
      ],
      chart: {
        height: "300px",
        width: "100%",
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        toolbar: {
          show: true,
        },
      },
      colors: ["#ffc107", "#545454"],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "smooth",
      },
      title: {
        text: "",
        align: "left",
      },
      grid: {
        show: false,
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0,
        },
      },
      markers: {
        size: 6,
        hover: {
          size: 16,
        },
      },
      xaxis: {
        type: "category",
        categories: e2,
      },
      yaxis: {
        min: 0,
        max: 100,
        title: {
          text: "Score sécurité (%)",
        },
      },
      tooltip: {
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        },
        marker: {
          show: false,
        },
        y: {
          formatter: (values) => {
            return (
              values +
              ' %  <img src="https://img.icons8.com/color/20/000000/average-value.png"/> Moyenne: ' +
              avg +
              "%"
            );
          },
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5,
      },
      annotations: {
        yaxis: [
          {
            y: avg,
            borderColor: "#00E396",
            label: {
              borderColor: "#00E396",
              style: {
                color: "#fff",
                background: "#00E396",
              },
              text: "Moyenne " + avg + "%",
            },
          },
        ],
      },
    };
  }

  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: item };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
  }
  showChartEvolutionScoreSecurite() {
    this.evolutionScoreSecurite = !this.evolutionScoreSecurite;
  }

  showChartEvolutionScoreEconomie() {
    this.evolutionScoreEconomie = !this.evolutionScoreEconomie;
  }

  charttypeEvenement: any = {
    chart: {
      selection: {
        enabled: true,
      },

      //   height: '300px',
      //   width: '100%',
      //   type: "line",
      //   dropShadow: {
      //     enabled: true,
      //     color: "#000",
      //     top: 18,
      //     left: 7,
      //     blur: 10,
      //     opacity: 0.2
      //   },
      //   toolbar: {
      //     tools: {
      //         download: true,
      //         selection: true,
      //         zoom: true,
      //         zoomin: true,
      //         zoomout: true,
      //         pan: true,
      //     }
      // }
    },
  };
  showChartTypeEvenement() {
    this.typeEvenement = !this.typeEvenement;
  }

  showChartRelationSecuriteEconomie() {
    this.relationSecuriteEconomie = !this.relationSecuriteEconomie;
  }

  showChartRepartitionScoreSecurite() {
    this.repartitionScoreSecurite = !this.repartitionScoreSecurite;
  }

  showChartRepartitionScoreEconomie() {
    this.repartitionScoreEconomie = !this.repartitionScoreEconomie;
  }

  getUserrefrech() {
    this.executeFunction();
  }

  displayedColumns: string[] = [
    "name",
    "unit_type",
    "distance_traveled",
    "trip_duration",
    "avg_distance",
    "avg_speed",
    "safety_score",
    "safety_score_tendency",
    "diff_safety_score",
    "km_between_maneuvers",
    "nb_maneuvers",
    "eco_score",
    "eco_score_tendency",
    "diff_eco_score",
    "idle_time",
  ];
  // Assign the data to the data source for the table to render

  pipe: DatePipe;

  filterForm = new FormGroup({
    fromDate: new FormControl(new Date()),
    toDate: new FormControl(new Date()),
  });

  get fromDate() {
    return this.filterForm.get("fromDate").value;
  }
  get toDate() {
    return this.filterForm.get("toDate").value;
  }

  rangeFormGroup2 = new FormGroup({
    dt10: new FormControl(),
  });

  getChartGauge(distMoy, distMax, distMin, vitesseMoy, vitesseMax, VitesseMin) {
    this.singleDistance = [
      {
        name: "Distance Moyenne",
        value: distMoy,
      },
    ];
    this.formatDist = (val) => {
      return distMoy + "Km";
    };

    this.minDist = distMin;
    this.maxDist = distMax;

    this.singleVitesse = [
      {
        name: "Distance Moyenne",
        value: vitesseMoy,
      },
    ];
    this.formatVitesse = (val) => {
      return vitesseMoy + " Km/h";
    };

    this.minVitesse = VitesseMin;
    this.maxVitesse = vitesseMax;
  }

  dbClickitem(e) {
    let url = "user/vehicule/details/" + e;
    this.router.navigate([url]);
  }
  getChrt(e, ec, sc) {
    this.chartOptions = {
      series: [
        {
          data: e,
        },
      ],
      chart: {
        height: "400px",
        width: "100%",
        type: "bubble",
        events: {
          dataPointSelection: (event, chartContext, config) => {
            this.router.navigate([
              "user/vehicule/details/" +
                this.series11[config.dataPointIndex][3].split("Name.")[0],
            ]);
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      bubble: {
        minBubbleRadius: 10,
        maxBubbleRadius: 10,
      },
      fill: {
        opacity: 0.7,
      },
      title: {
        text: "",
      },
      xaxis: {
        tooltip: {
          enabled: false,
        },
        min: 0,
        max: 100,

        type: "category",
        tickAmount: 10,
        title: {
          text: "score économie (%)",
          rotate: -90,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 550,
            cssClass: "apexcharts-yaxis-title",
          },
        },
      },
      annotations: {
        yaxis: [
          {
            y: sc,
            borderColor: "#ffcc36",
            label: {
              borderColor: "#ffcc36",
              style: {
                color: "#fff",
                background: "#ffcc36",
              },
              text: "Y-axis moyenne " + sc + "%",
            },
          },
        ],
        xaxis: [
          {
            x: ec,
            borderColor: "#00E396",
            label: {
              borderColor: "#00E396",
              style: {
                color: "#fff",
                background: "#00E396",
              },
              text: "X-axis moyenne " + ec + "%",
            },
          },
        ],
      },
      yaxis: {
        max: 100,
        title: {
          text: "score securité (%)",
          rotate: -90,
          offsetX: 10,
          offsetY: 0,
          style: {
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 550,
            cssClass: "apexcharts-yaxis-title",
          },
        },
      },

      tooltips: {
        enabled: true,

        onDatasetHover: {
          highlightDataSeries: false,
        },
        x: {
          show: false,
          formatter: (values) => {
            this.xValues = values;
          },
        },
        y: {
          formatter: (values) => {
            return (this.yValues = values);
          },
          title: {
            formatter: (
              seriesName,
              { series, seriesIndex, dataPointIndex, w }
            ) =>
              '<img src="https://img.icons8.com/color/20/000000/convertible-roof-warning.png"/> <b> Véhicule : </b>  <b> ' +
              this.series11[dataPointIndex][3].split("Name.")[1] +
              '</b><br/><hr>  <img src="https://img.icons8.com/color/20/000000/warning-shield.png"/> <b> Score de sécurité:</b>  ',
          },
        },
        z: {
          formatter: (values) => {
            return this.xValues;
          },

          title:
            '<img src="https://img.icons8.com/color/20/000000/natural-food.png"/> <b>Score économie :</b>',
        },
      },
    };
  }

  getchrt4(e, e1, e2, avg, int_sc) {
    this.chartOptions4 = {
      series: e,
      colors: e2,

      chart: {
        width: "100%",
        height: "300px",
        type: "donut",
        dropShadow: {
          enabled: true,
          color: "#111",
          top: -1,
          left: 3,
          blur: 3,
          opacity: 0.2,
        },
        toolbar: {
          show: true,
        },
      },
      stroke: {
        width: 0,
      },
      plotOptions: {
        pie: {
          startAngle: 0,
          expandOnClick: true,
          offsetX: 0,
          offsetY: 0,
          customScale: 1,
          dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10,
          },
          donut: {
            size: "65%",
            background: "transparent",
            labels: {
              show: true,
              /*  name: {
                 show: true,
                 fontSize: '80px',
                 fontFamily: 'Helvetica, Arial, sans-serif',
                 fontWeight: 600,
                 color: undefined,
                 offsetY: -10,
                 formatter: function (val) {
                   return  avg +'%'
                 }
               }, */
              value: {
                show: true,
                fontSize: "16px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: 400,
                color: undefined,
                offsetY: 16,
                formatter: function (val) {
                  return avg + "%";
                },
              },
              total: {
                show: true,
                showAlways: false,
                label: "Moyenne",
                fontSize: "15px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: 600,
                color: "#373d3f",
                formatter: function (w) {
                  return (
                    w.globals.seriesTotals.reduce((a, b) => {
                      return avg;
                    }, 0) + "%"
                  );
                },
              },
            },
          },
        },
      },
      tooltip: {
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        },
        marker: {
          show: false,
        },
        y: {
          formatter: (values) => {
            return (
              'Intervalle de score <img src="https://img.icons8.com/color/20/000000/accounting.png"/> Nombre des véhicules: ' +
              values
            );
          },
        },
      },
      dataLabels: {
        enabled: true,

        dropShadow: {
          enabled: true,
          left: 2,
          top: 2,
          opacity: 0.5,
        },
      },

      legend: {
        show: true,
        position: "bottom",
      },

      fill: {
        /* type: "pattern", */
        opacity: 1,
        colors: e2,
        pattern: {
          enabled: true,
          style: e1,
        },
      },
      labels: int_sc,

      states: {
        title: " gfg",
        hover: {
          filter: {
            type: "none",
          },
        },
      },
      theme: {
        palette: "palette2",
      },
      title: {
        text: "",
      },
    };
  }

  getchrt1(e, e1, e2, avg, int_sc) {
    this.chartOptions2 = {
      series: e,
      colors: e2,

      chart: {
        width: "100%",
        height: "300px",
        type: "donut",
        dropShadow: {
          enabled: true,
          color: "#111",
          top: -1,
          left: 3,
          blur: 3,
          opacity: 0.2,
        },
        toolbar: {
          show: true,
        },
      },
      stroke: {
        width: 0,
      },
      plotOptions: {
        pie: {
          startAngle: 0,
          expandOnClick: true,
          offsetX: 0,
          offsetY: 0,
          customScale: 1,
          dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10,
          },
          donut: {
            size: "65%",
            background: "transparent",
            labels: {
              show: true,

              value: {
                show: true,
                fontSize: "16px",
                fontWeight: 400,
                color: undefined,
                offsetY: 16,
                formatter: function (val) {
                  return avg + "%";
                },
              },
              total: {
                show: true,
                showAlways: false,
                label: "Moyenne",
                fontSize: "15px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: 600,
                color: "#373d3f",
                formatter: function (w) {
                  return (
                    w.globals.seriesTotals.reduce((a, b) => {
                      return avg;
                    }, 0) + "%"
                  );
                },
              },
            },
          },
        },
      },

      dataLabels: {
        enabled: true,

        dropShadow: {
          enabled: true,
          left: 2,
          top: 2,
          opacity: 0.5,
        },
      },

      legend: {
        show: true,
        position: "bottom",
      },

      fill: {
        /* type: "pattern", */
        opacity: 1,
        colors: e2,
        pattern: {
          enabled: true,
          style: e1,
        },
      },
      labels: int_sc,

      states: {
        title: " gfg",
        hover: {
          filter: {
            type: "none",
          },
        },
      },
      theme: {
        palette: "palette2",
      },
      title: {
        text: "",
      },

      tooltip: {
        background: "red",
        color: "orange",
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        },
        marker: {
          show: false,
        },
        y: {
          formatter: (values) => {
            return (
              'Intervalle de score <img src="https://img.icons8.com/color/20/000000/accounting.png"/> Nombre des véhicules: ' +
              values
            );
          },
        },
      },
    };
  }

  rangeForm = new FormGroup({
    start: new FormControl(new Date(localStorage.getItem("startDateValue"))),
    end: new FormControl(new Date(localStorage.getItem("endDateValue"))),
  });

  executeFunction() {
    this.addNewDate(this.rangeForm);
  }
  addNewDate(e) {
    var DateStart = new Date(e.value.start)?.toString().split("(")[0];
    //this.minDate = new Date(e.value.start)

    var DateEnd2 = new Date(e.value.end)?.toISOString();
    var DateEnd = new Date(e.value.end)?.toString().split("(")[0];

    if (DateEnd2 != "1970-01-01T00:00:00.000Z") {
      localStorage.setItem(
        "startDateValue",
        new Date(this.rangeForm.value.start).toString()
      );
      localStorage.setItem(
        "endDateValue",
        new Date(this.rangeForm.value.end).toString()
      );
      this.getdd(DateStart, DateEnd);
    } else {
    }
  }
  getFilter() {
    //console.log(this.filterForm.value)
    this.range = (<HTMLInputElement>document.getElementById("dateTime")).value;
    //console.log(this.range.split(',')[0].split('/')[2])    //var firstD =this.range.split('~')[0].split(',')[0]
    var firstD = "9/23/2016";
    var firstT = this.range.split("~")[0].split(",")[1].split(" ")[1];
    //   var secondD = this.range.split('~')[1].split(',')[0]
    var secondD = "9/23/2020";
    var secondT = this.range.split("~")[1].split(",")[1].split(" ")[1];
    var filterDT = firstD + "--" + secondD;
    this.pipe = new DatePipe("en");
    //console.log(new Date(firstD).getUTCDate())
    var e = new Date(firstD).getUTCDate();
    //console.log(e)
    this.filterValue = filterDT.replace(/\s/g, "");

    const defaultPredicate = this.dataSource.filterPredicate;
    //console.log(this.range + "range")
  }

  updateColor(progress) {
    if (progress < 55) {
      return "#dc3545";
    } else if (progress > 75) {
      return "#28a745";
    } else {
      return "#fd8021";
    }
  }

  getFilterChoise(filterdte) {
    (<HTMLInputElement>document.getElementById("getdt")).value = "";

    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.pipe = new DatePipe("en");
    this.days = this.pipe.transform(new Date(), "M/d/yyyy");
    //console.log(this.days + new Date())

    var date = new Date();
    date.setDate(date.getDate() - filterdte);

    this.finalDate =
      date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    //console.log((new Date).toString().substr(0, 24), date.toString().substr(0, 24))
    var periodeFilter =
      date.toString().substr(0, 24) + "~" + new Date().toString().substr(0, 24);
    localStorage.setItem("startDateValue", new Date(date).toString());
    localStorage.setItem("endDateValue", new Date().toString());

    this.getdd(
      date.toString().substr(0, 24),
      new Date().toString().substr(0, 24)
    );
  }

  selectedRowIndex = -1;

  getItemDetails(e) {
    this.itemSelect = e;
    //console.log(e)
    this.selectedRowIndex = e.id;

    this.hiddenDetails = true;
  }

  selectedRowIndex2 = -1;

  // MatPaginator Output
  pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput
        .split(",")
        .map((str) => +str);
    }
  }

  public updateManualPage(index): void {
    //console.log(index)
    this.pageNum = index;
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator?.pageIndex,
      pageSize: this.paginator?.pageSize,
      length: this.paginator?.length,
    });
  }

  collection: any;

  public updateManualPage2(index2): void {
    this.collection = [];

    //console.log(this.pageSizeOptions1)
    this.paginator.pageSize = index2;

    this.paginator.page.next({
      pageIndex: this.paginator?.pageIndex,
      pageSize: this.paginator?.pageSize,
      length: this.paginator?.length,
    });

    this.lengthpage = parseInt("" + this.paginator?.length / index2);

    //console.log(this.lengthpage)

    //Create dummy data
    for (var i = 0; i < this.lengthpage; i++) {
      this.collection.push(i + 1);
    }

    //console.log(this.collection)
  }

  applyFilterer(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportExcel(e, e2) {
    Swal.fire({
      title: "Souhaitez-vous exporter la table ?",
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      showCancelButton: true,
      confirmButtonText: "Démarrer l'exportation",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Export!", "le fichier est exporté");
        //console.log(e);
        e.exportTable(e2, {
          fileName: "STG_DRIVE_vehicule_date_" + new Date().toLocaleString(),
          sheet: "STG DRIVE Vehicule",
          Props: { Author: "STG_DRIVE" },
        });
      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire("Annulé", "Fichier non exporté !!");
      }
    });
  }

  exportTable() {
    Swal.fire({
      title: "Souhaitez-vous  exporter la table ?",
      showCancelButton: true,
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Démarrer l'exportation",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        PDFfile.exportToPdf("ExampleTable", "tbl");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Annulé", "Fichier non exporté !!");
      }
    });
  }
}
